export default __webpack_public_path__ + "static/media/41217047470_45aa7a4651_k.3b55f45b.jpg";